import { Loader, Modal } from "@monolith-forensics/monolith-ui";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import ShareItemForm from "../Forms/ShareItemForm";
import { FilesAPI } from "../files.api";
import { File } from "../files.types";

export const ShareItemModal = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultValues,
  buttonProps,
}: {
  show: boolean;
  onClose: () => void;
  onSubmit: (values: any) => void;
  onCancel: () => void;
  defaultValues?: {
    emails?: string[];
    message?: string;
    selectedItems?: File[];
    caseInfo?: { uuid: string; case_id: number };
  };
  buttonProps?: { cancelText?: string; submitText?: string };
}) => {
  const [submitting, setSubmitting] = useState<boolean>(false);

  const shareItems = useMutation({
    mutationFn: FilesAPI.shareItems,
    onMutate: async () => {
      setSubmitting(true);
    },
    onSuccess: (data, values) => {
      setSubmitting(false);
      onSubmit?.(values);
    },
  });

  const handleSubmit = async (values: {
    emails?: string[];
    message?: string;
    selectedItems?: File[];
    caseInfo?: { uuid: string; case_id: number };
  }) => {
    const { emails, selectedItems, message, caseInfo } = values;

    if (!selectedItems || !emails) {
      return;
    }

    shareItems.mutate({
      items: selectedItems.map((item: File) => ({
        name: item.name,
        uuid: item.uuid,
        type: item.is_folder ? "folder" : "file",
        share_data: {
          message,
        },
      })),
      case_uuid: caseInfo?.uuid,
      emails,
      message,
    });
  };

  return (
    <Modal open={show} onClose={onClose}>
      <Modal.Title>Share Items</Modal.Title>
      <Modal.SubTitle style={{ marginBottom: 15 }}>
        Share items with other users via Relay.
      </Modal.SubTitle>
      <div></div>
      {submitting ? (
        <Loader />
      ) : (
        <ShareItemForm
          onSubmit={handleSubmit}
          onCancel={onCancel}
          buttonProps={buttonProps}
          defaultFormData={defaultValues}
        />
      )}
    </Modal>
  );
};
